import { render, staticRenderFns } from "./total-loan-amount.vue?vue&type=template&id=aba1a204"
import script from "./total-loan-amount.vue?vue&type=script&lang=js"
export * from "./total-loan-amount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports